import React from 'react'

const PolygonSVG: React.FC = () => {
    return (
        <svg version="1.1" x="0px" y="0px" viewBox="0 0 40 40">
            <polygon
                fill={'none'}
                stroke={'#000'}
                strokeWidth={2}
                strokeMiterlimit={10}
                points={'20,3.8 3,16.2 9.5,36.2 30.5,36.2 37,16.2'}
            />
        </svg>
    )
}

export default PolygonSVG
